<template>
  <div id="member" class="application-section">
    <section id="regNumberSection">
       <div class="container is-fluid">
        <FreetextQuestion question="My GPhC/RCPharm number is" :class="{error: $v.understandingYou.registrationNumber.$error }"
         @question-answered="registrationNumberEntered" :existingValue="understandingYou.registrationNumber" :isMandatory="true"
                          :tab="sections.regNumberSection.tab" :placeholder="'2345678'"/>
         <ChooseQuestion  question="and I qualified in" :options="qualifiedDates"
          :class="{error: $v.understandingYou.qualifiedDate.$error }"
          @question-answered="qualifiedDateSelected" closingSentence="."
          :existingValue="understandingYou.qualifiedDate" :isMandatory="true"
          :tab="sections.regNumberSection.tab"/>
       </div>
    </section>
    <!--<section id="investigationSection" :class="sections.investigationSection">
      <div class="container is-fluid">
        <ChooseQuestion question="I" :options="wasSubject" :existingValue="understandingYou.wasSubject"
                        closingSentence="subject to a fitness to practice investigation."
                        :class="{error: $v.understandingYou.wasSubject.$error}"
                        @question-answered="wasSubjectSelected" :isDisabled="sections.investigationSection.ghost"
                        :isMandatory="true" :isDropdownControlled="true" :tab="sections.investigationSection.tab"/>
        <FreetextQuestion  :isNewLine="true" maxlength="255" question="Please tell us more about the fitness to practice investigation:"
                          :placeholder="placeholder" :existingValue="understandingYou.subjectedDetails"
                          :class="{error: $v.understandingYou.subjectedDetails.$error}" :tab="sections.investigationSection.tab"
                          v-if="wasSubjectedToFitnessInvest" @question-answered="wasSubjectedDetails"
                          :isDisabled="sections.investigationSection.ghost"
                          :isMandatory="wasSubjectedToFitnessInvest" :isExtraQuestion="true" :isNotDisplayed="true" />
      </div>
    </section>-->
    <section id="dropdownSection" :class="sections.dropdownSection">
       <div class="container is-fluid">
      <ChooseQuestion question="My primary sector of pharmacy is"
         :existingValue="understandingYou.sector" :tab="sections.dropdownSection.tab"
         :options="sectors" @question-answered="(s) => understandingYou.sector = s.text" closingSentence="."
         :isDisabled="sections.dropdownSection.ghost" :isDropdownControlled="true"/>
      <ChooseQuestion question="My primary occupation in pharmacy is best described as" :options="memberOccupations"
        :existingValue="understandingYou.occupation" :tab="sections.dropdownSection.tab"
         @question-answered="(o) => understandingYou.occupation = o.text" closingSentence="." :isDisabled="sections.dropdownSection.ghost"
         :isDropdownControlled="true"/>
        </div>
    </section>
    <section id="employmentDetails" :class="sections.employmentDetails">
      <div class="container is-fluid">
        <ChooseQuestion question="I am currently" :tab="sections.employmentDetails.tab"
                        :existingValue="understandingYou.employmentStatus"
                        :options="employmentStatuses" @question-answered="empStatusSelected" closingSentence="."
                        :isDisabled="sections.employmentDetails.ghost"
                        :class="[{error: $v.understandingYou.employmentStatus.$error}, 'employment-size']"
                        :isMandatory="true"
                        :isDropdownControlled="true" />
        <div v-html="locumSelfEmployedMessage"></div>
        <FreetextQuestion :question="workStatement" :existingValue="understandingYou.jobTitle"
                          @question-answered="(j) => understandingYou.jobTitle = j" :isDisabled="sections.employmentDetails.ghost"
                          :tab="sections.employmentDetails.tab" closingTag="." />
        <FreetextQuestion question="at" @question-answered="understandingYou.organization = $event" :tab="sections.employmentDetails.tab"
                          closingTag="." :isNotDisplayed="true" :existingValue="understandingYou.organization"
                          maxlength="100" />
      </div>
    </section>
    <section id="areYouSection" :class="sections.areYouSection">
      <div class="container is-fluid">
        <p>I am a:</p>
        <CheckboxQuestion question="Independent prescriber" @question-answered="(ip) => understandingYou.isIndependentPrescriber = ip"
                          :isDisabled="sections.areYouSection.ghost" :existingValue="understandingYou.isIndependentPrescriber"
                          :tab="sections.areYouSection.tab"/>
        <CheckboxQuestion question="Supplementary prescriber" @question-answered="(sp) => understandingYou.isSupplementaryPrescriber = sp"
                          :isDisabled="sections.areYouSection.ghost" :existingValue="understandingYou.isSupplementaryPrescriber"
                          :tab="sections.areYouSection.tab"/>
        <CheckboxQuestion question="Designated Supervisor" @question-answered="(t) => understandingYou.isPreRegTutor = t"
                          :isDisabled="sections.areYouSection.ghost" :existingValue="understandingYou.isPreRegTutor"
                          :tab="sections.areYouSection.tab"/>
          <div v-if="!this.$store.state.isMobile" id="confirm-wrap">
            <button class="btn-confirm" @click.stop.prevent="$emit('confirmClicked')" type="button">Next</button>
          </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable no-unused-expressions */
import { mapGetters } from 'vuex';
import FreetextQuestion from '@/components/FreetextQuestion.vue';
import ChooseQuestion from '@/components/ChooseQuestion.vue';
import CheckboxQuestion from '@/components/CheckboxQuestion.vue';
import '@/styles/application.scss';
import {
  required,
} from 'vuelidate/lib/validators';
import ghost from '@/understandingyou/scripts/ghost';

export default {
  name: 'Member',
  components: {
    FreetextQuestion,
    ChooseQuestion,
    CheckboxQuestion,
  },
  props: {
    dataGetter: Function,
  },
  data() {
    return {
      placeholder: 'Tell us more',
      wasSubject: [{ text: 'have not been', value: '1' }, { text: 'am / have been', value: '2' }],
      sections: {
        regNumberSection: { hidden: false, ghost: false, tab: 0 },
        dropdownSection: { hidden: false, ghost: true, tab: this.$store.state.isMobile ? -1 : 0 },
        employmentDetails: { hidden: true, ghost: false, tab: this.$store.state.isMobile ? -1 : 0 },
        areYouSection: { hidden: true, ghost: false, tab: this.$store.state.isMobile ? -1 : 0 },
      },
      understandingYou: this.dataGetter(),
    };
  },
  updated() {
    this.$emit('onFinalSection', this.isFinalSectionVisible);
  },
  computed: {
    ...mapGetters(['employmentStatuses', 'qualifiedDates', 'sectors', 'memberOccupations', 'locumSelfEmployedMessage']),
    isFinalSectionVisible() {
      return this.sections.areYouSection.hidden === false;
    },
    wasSubjectedToFitnessInvest() {
      return this.understandingYou.wasSubject === 'am / have been';
    },
    workStatement() {
      return ghost.workStatement(this.understandingYou.employmentStatus);
    },
  },
  validations() {
    return {
      understandingYou: {
        registrationNumber: {
          required,
        },
        qualifiedDate: {
          required,
        },
        employmentStatus: {
          required,
        },
      },
    };
  },
  methods: {
    HasErrorInSection(currentSection) {
      if (currentSection === 'regNumberSection') {
        this.$v.understandingYou.registrationNumber.$touch();
        this.$v.understandingYou.qualifiedDate.$touch();
        return this.$v.understandingYou.registrationNumber.$error || this.$v.understandingYou.qualifiedDate.$error;
      }
      if (currentSection === 'employmentDetails') {
        this.$v.understandingYou.employmentStatus.$touch();
        return this.$v.understandingYou.employmentStatus.$error;
      }
      return false;
    },
    registrationNumberEntered(rn) {
      this.understandingYou.registrationNumber = rn;
      this.$v.understandingYou.registrationNumber.$touch();
    },
    qualifiedDateSelected(qd) {
      this.understandingYou.qualifiedDate = qd.text;
      this.$v.understandingYou.qualifiedDate.$touch();
      ghost.showSection(this.sections.dropdownSection);
      ghost.showSection(this.sections.employmentDetails);
      ghost.ghostSection(this.sections.areYouSection);
      // ghost.ghostSection(this.sections.dropdownSection);
    },
    wasSubjectSelected(s) {
      this.understandingYou.wasSubject = s.text;
      this.$v.understandingYou.wasSubject.$touch();
      ghost.showSection(this.sections.dropdownSection);
      ghost.showSection(this.sections.employmentDetails);
      ghost.ghostSection(this.sections.areYouSection);
    },
    wasSubjectedDetails(subDetail) {
      this.understandingYou.subjectedDetails = subDetail;
      this.$v.understandingYou.subjectedDetails.$touch();
    },
    empStatusSelected(e) {
      this.understandingYou.employmentStatus = e.text;
      this.$v.understandingYou.employmentStatus.$touch();
      ghost.showSection(this.sections.areYouSection);
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
  },
};
</script>
